import React, { Suspense, lazy } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
// Eagerly loaded (critical path)
import { HomePage } from './pages/HomePage';
// Lazy loaded pages
const WebsiteLatenMakenPage = lazy(() => import('./pages/WebsiteLatenMakenPage').then(m => ({
  default: m.WebsiteLatenMakenPage
})));
const SeoVoorWebsitesPage = lazy(() => import('./pages/SeoVoorWebsitesPage').then(m => ({
  default: m.SeoVoorWebsitesPage
})));
const WordPressWebsitesPage = lazy(() => import('./pages/WordPressWebsitesPage').then(m => ({
  default: m.WordPressWebsitesPage
})));
const HostingOnderhoudPage = lazy(() => import('./pages/HostingOnderhoudPage').then(m => ({
  default: m.HostingOnderhoudPage
})));
const WebsiteHostingPage = lazy(() => import('./pages/WebsiteHostingPage').then(m => ({
  default: m.WebsiteHostingPage
})));
const WebsiteLatenMakenAlkmaarPage = lazy(() => import('./pages/WebsiteLatenMakenAlkmaarPage').then(m => ({
  default: m.WebsiteLatenMakenAlkmaarPage
})));
const KostenWebsiteLatenMakenPage = lazy(() => import('./pages/KostenWebsiteLatenMakenPage').then(m => ({
  default: m.KostenWebsiteLatenMakenPage
})));
const WebsiteLatenMakenChecklistPage = lazy(() => import('./pages/WebsiteLatenMakenChecklistPage').then(m => ({
  default: m.WebsiteLatenMakenChecklistPage
})));
const WebsiteLatenMakenOfZelfBouwenPage = lazy(() => import('./pages/WebsiteLatenMakenOfZelfBouwenPage').then(m => ({
  default: m.WebsiteLatenMakenOfZelfBouwenPage
})));
const WordPressVsWixPage = lazy(() => import('./pages/WordPressVsWixPage').then(m => ({
  default: m.WordPressVsWixPage
})));
const KennisbankPage = lazy(() => import('./pages/KennisbankPage').then(m => ({
  default: m.KennisbankPage
})));
const WordPressWebsiteAlkmaarPage = lazy(() => import('./pages/WordPressWebsiteAlkmaarPage').then(m => ({
  default: m.WordPressWebsiteAlkmaarPage
})));
const WordPressOnderhoudPage = lazy(() => import('./pages/WordPressOnderhoudPage').then(m => ({
  default: m.WordPressOnderhoudPage
})));
const WebsiteOnderhoudPage = lazy(() => import('./pages/WebsiteOnderhoudPage').then(m => ({
  default: m.WebsiteOnderhoudPage
})));
const WebsiteBeveiligingPage = lazy(() => import('./pages/WebsiteBeveiligingPage').then(m => ({
  default: m.WebsiteBeveiligingPage
})));
const WebsiteTipsPage = lazy(() => import('./pages/WebsiteTipsPage').then(m => ({
  default: m.WebsiteTipsPage
})));
const WebsiteVoorbeeldenPage = lazy(() => import('./pages/WebsiteVoorbeeldenPage').then(m => ({
  default: m.WebsiteVoorbeeldenPage
})));
const WebsiteMarketingPage = lazy(() => import('./pages/WebsiteMarketingPage').then(m => ({
  default: m.WebsiteMarketingPage
})));
const PortfolioPage = lazy(() => import('./pages/PortfolioPage').then(m => ({
  default: m.PortfolioPage
})));
// Sectors
const SectorZakelijkeDienstverleningPage = lazy(() => import('./pages/SectorZakelijkeDienstverleningPage').then(m => ({
  default: m.SectorZakelijkeDienstverleningPage
})));
const SectorBouwInstallatiePage = lazy(() => import('./pages/SectorBouwInstallatiePage').then(m => ({
  default: m.SectorBouwInstallatiePage
})));
const SectorMakelaarsVastgoedPage = lazy(() => import('./pages/SectorMakelaarsVastgoedPage').then(m => ({
  default: m.SectorMakelaarsVastgoedPage
})));
const SectorZorgpraktijkenPage = lazy(() => import('./pages/SectorZorgpraktijkenPage').then(m => ({
  default: m.SectorZorgpraktijkenPage
})));
const SectorHorecaHospitalityPage = lazy(() => import('./pages/SectorHorecaHospitalityPage').then(m => ({
  default: m.SectorHorecaHospitalityPage
})));
const SectorCoachesConsultantsPage = lazy(() => import('./pages/SectorCoachesConsultantsPage').then(m => ({
  default: m.SectorCoachesConsultantsPage
})));
const SectorLokaleRetailPage = lazy(() => import('./pages/SectorLokaleRetailPage').then(m => ({
  default: m.SectorLokaleRetailPage
})));
// Clusters
const ClusterAccountantPage = lazy(() => import('./pages/ClusterAccountantPage').then(m => ({
  default: m.ClusterAccountantPage
})));
const KostenWebsiteAccountantPage = lazy(() => import('./pages/KostenWebsiteAccountantPage').then(m => ({
  default: m.KostenWebsiteAccountantPage
})));
const ClusterBouwbedrijfPage = lazy(() => import('./pages/ClusterBouwbedrijfPage').then(m => ({
  default: m.ClusterBouwbedrijfPage
})));
const ClusterLoodgieterPage = lazy(() => import('./pages/ClusterLoodgieterPage').then(m => ({
  default: m.ClusterLoodgieterPage
})));
const ClusterElektricienPage = lazy(() => import('./pages/ClusterElektricienPage').then(m => ({
  default: m.ClusterElektricienPage
})));
const ClusterDakdekkerPage = lazy(() => import('./pages/ClusterDakdekkerPage').then(m => ({
  default: m.ClusterDakdekkerPage
})));
const ClusterMakelaarPage = lazy(() => import('./pages/ClusterMakelaarPage').then(m => ({
  default: m.ClusterMakelaarPage
})));
const ClusterProjectontwikkelaarPage = lazy(() => import('./pages/ClusterProjectontwikkelaarPage').then(m => ({
  default: m.ClusterProjectontwikkelaarPage
})));
const ClusterVastgoedbeheerPage = lazy(() => import('./pages/ClusterVastgoedbeheerPage').then(m => ({
  default: m.ClusterVastgoedbeheerPage
})));
const ClusterWoningpresentatiePage = lazy(() => import('./pages/ClusterWoningpresentatiePage').then(m => ({
  default: m.ClusterWoningpresentatiePage
})));
const ClusterFysiotherapiePage = lazy(() => import('./pages/ClusterFysiotherapiePage').then(m => ({
  default: m.ClusterFysiotherapiePage
})));
const ClusterTandartsPage = lazy(() => import('./pages/ClusterTandartsPage').then(m => ({
  default: m.ClusterTandartsPage
})));
const ClusterHuisartsPage = lazy(() => import('./pages/ClusterHuisartsPage').then(m => ({
  default: m.ClusterHuisartsPage
})));
const ClusterPsycholoogPage = lazy(() => import('./pages/ClusterPsycholoogPage').then(m => ({
  default: m.ClusterPsycholoogPage
})));
const ClusterRestaurantPage = lazy(() => import('./pages/ClusterRestaurantPage').then(m => ({
  default: m.ClusterRestaurantPage
})));
const ClusterHotelBbPage = lazy(() => import('./pages/ClusterHotelBbPage').then(m => ({
  default: m.ClusterHotelBbPage
})));
const ClusterCafeLunchroomPage = lazy(() => import('./pages/ClusterCafeLunchroomPage').then(m => ({
  default: m.ClusterCafeLunchroomPage
})));
const ClusterAfhaalBezorgPage = lazy(() => import('./pages/ClusterAfhaalBezorgPage').then(m => ({
  default: m.ClusterAfhaalBezorgPage
})));
const ClusterCoachingPage = lazy(() => import('./pages/ClusterCoachingPage').then(m => ({
  default: m.ClusterCoachingPage
})));
const ClusterConsultantPage = lazy(() => import('./pages/ClusterConsultantPage').then(m => ({
  default: m.ClusterConsultantPage
})));
const ClusterSportschoolPage = lazy(() => import('./pages/ClusterSportschoolPage').then(m => ({
  default: m.ClusterSportschoolPage
})));
const ClusterPersonalTrainerPage = lazy(() => import('./pages/ClusterPersonalTrainerPage').then(m => ({
  default: m.ClusterPersonalTrainerPage
})));
const ClusterKapsalonPage = lazy(() => import('./pages/ClusterKapsalonPage').then(m => ({
  default: m.ClusterKapsalonPage
})));
const ClusterFietsenwinkelPage = lazy(() => import('./pages/ClusterFietsenwinkelPage').then(m => ({
  default: m.ClusterFietsenwinkelPage
})));
const ClusterGaragePage = lazy(() => import('./pages/ClusterGaragePage').then(m => ({
  default: m.ClusterGaragePage
})));
const ClusterAutobedrijfPage = lazy(() => import('./pages/ClusterAutobedrijfPage').then(m => ({
  default: m.ClusterAutobedrijfPage
})));
// New high-intent pages
const AccountantAmsterdamPage = lazy(() => import('./pages/AccountantAmsterdamPage').then(m => ({
  default: m.AccountantAmsterdamPage
})));
const FinancieelAdviseurAmsterdamPage = lazy(() => import('./pages/FinancieelAdviseurAmsterdamPage').then(m => ({
  default: m.FinancieelAdviseurAmsterdamPage
})));
// Local pages
const WebdesignAlkmaarPage = lazy(() => import('./pages/WebdesignAlkmaarPage').then(m => ({
  default: m.WebdesignAlkmaarPage
})));
const WebdesignHeerhugowaardPage = lazy(() => import('./pages/WebdesignHeerhugowaardPage').then(m => ({
  default: m.WebdesignHeerhugowaardPage
})));
const WebdesignHoornPage = lazy(() => import('./pages/WebdesignHoornPage').then(m => ({
  default: m.WebdesignHoornPage
})));
const WebdesignSchagenPage = lazy(() => import('./pages/WebdesignSchagenPage').then(m => ({
  default: m.WebdesignSchagenPage
})));
const WebdesignDenHelderPage = lazy(() => import('./pages/WebdesignDenHelderPage').then(m => ({
  default: m.WebdesignDenHelderPage
})));
const WebdesignDijkEnWaardPage = lazy(() => import('./pages/WebdesignDijkEnWaardPage').then(m => ({
  default: m.WebdesignDijkEnWaardPage
})));
const WebdesignCastricumPage = lazy(() => import('./pages/WebdesignCastricumPage').then(m => ({
  default: m.WebdesignCastricumPage
})));
const WebdesignHeilooPage = lazy(() => import('./pages/WebdesignHeilooPage').then(m => ({
  default: m.WebdesignHeilooPage
})));
const WebdesignUitgeestPage = lazy(() => import('./pages/WebdesignUitgeestPage').then(m => ({
  default: m.WebdesignUitgeestPage
})));
const WebdesignBergenPage = lazy(() => import('./pages/WebdesignBergenPage').then(m => ({
  default: m.WebdesignBergenPage
})));
const WebdesignPurmerendPage = lazy(() => import('./pages/WebdesignPurmerendPage').then(m => ({
  default: m.WebdesignPurmerendPage
})));
const WebdesignHaarlemPage = lazy(() => import('./pages/WebdesignHaarlemPage').then(m => ({
  default: m.WebdesignHaarlemPage
})));
const WebdesignZaanstadPage = lazy(() => import('./pages/WebdesignZaanstadPage').then(m => ({
  default: m.WebdesignZaanstadPage
})));
const WebdesignHaarlemmermeerPage = lazy(() => import('./pages/WebdesignHaarlemmermeerPage').then(m => ({
  default: m.WebdesignHaarlemmermeerPage
})));
const WebdesignAmsterdamPage = lazy(() => import('./pages/WebdesignAmsterdamPage').then(m => ({
  default: m.WebdesignAmsterdamPage
})));
const WebdesignAmstelveenPage = lazy(() => import('./pages/WebdesignAmstelveenPage').then(m => ({
  default: m.WebdesignAmstelveenPage
})));
const WebdesignHilversumPage = lazy(() => import('./pages/WebdesignHilversumPage').then(m => ({
  default: m.WebdesignHilversumPage
})));
const WebdesignHuizenPage = lazy(() => import('./pages/WebdesignHuizenPage').then(m => ({
  default: m.WebdesignHuizenPage
})));
const WebdesignGooiseMerenPage = lazy(() => import('./pages/WebdesignGooiseMerenPage').then(m => ({
  default: m.WebdesignGooiseMerenPage
})));
const WebdesignVelsenPage = lazy(() => import('./pages/WebdesignVelsenPage').then(m => ({
  default: m.WebdesignVelsenPage
})));
const WebdesignBeverwijkPage = lazy(() => import('./pages/WebdesignBeverwijkPage').then(m => ({
  default: m.WebdesignBeverwijkPage
})));
const WebdesignHeemskerkPage = lazy(() => import('./pages/WebdesignHeemskerkPage').then(m => ({
  default: m.WebdesignHeemskerkPage
})));
const WebdesignTexelPage = lazy(() => import('./pages/WebdesignTexelPage').then(m => ({
  default: m.WebdesignTexelPage
})));
const WebdesignMedemblikPage = lazy(() => import('./pages/WebdesignMedemblikPage').then(m => ({
  default: m.WebdesignMedemblikPage
})));
const WebdesignEnkhuizenPage = lazy(() => import('./pages/WebdesignEnkhuizenPage').then(m => ({
  default: m.WebdesignEnkhuizenPage
})));
const WebdesignStedeBroecPage = lazy(() => import('./pages/WebdesignStedeBroecPage').then(m => ({
  default: m.WebdesignStedeBroecPage
})));
const WebdesignDrechterlandPage = lazy(() => import('./pages/WebdesignDrechterlandPage').then(m => ({
  default: m.WebdesignDrechterlandPage
})));
const WebdesignKoggenlandPage = lazy(() => import('./pages/WebdesignKoggenlandPage').then(m => ({
  default: m.WebdesignKoggenlandPage
})));
const WebdesignOpmeerPage = lazy(() => import('./pages/WebdesignOpmeerPage').then(m => ({
  default: m.WebdesignOpmeerPage
})));
const WebdesignHollandsKroonPage = lazy(() => import('./pages/WebdesignHollandsKroonPage').then(m => ({
  default: m.WebdesignHollandsKroonPage
})));
const WebdesignEdamVolendamPage = lazy(() => import('./pages/WebdesignEdamVolendamPage').then(m => ({
  default: m.WebdesignEdamVolendamPage
})));
const WebdesignWaterlandPage = lazy(() => import('./pages/WebdesignWaterlandPage').then(m => ({
  default: m.WebdesignWaterlandPage
})));
const WebdesignLandsmeerPage = lazy(() => import('./pages/WebdesignLandsmeerPage').then(m => ({
  default: m.WebdesignLandsmeerPage
})));
const WebdesignOostzaanPage = lazy(() => import('./pages/WebdesignOostzaanPage').then(m => ({
  default: m.WebdesignOostzaanPage
})));
const WebdesignWormerlandPage = lazy(() => import('./pages/WebdesignWormerlandPage').then(m => ({
  default: m.WebdesignWormerlandPage
})));
const WebdesignBloemendaalPage = lazy(() => import('./pages/WebdesignBloemendaalPage').then(m => ({
  default: m.WebdesignBloemendaalPage
})));
const WebdesignHeemstedePage = lazy(() => import('./pages/WebdesignHeemstedePage').then(m => ({
  default: m.WebdesignHeemstedePage
})));
const WebdesignZandvoortPage = lazy(() => import('./pages/WebdesignZandvoortPage').then(m => ({
  default: m.WebdesignZandvoortPage
})));
const WebdesignAalsmeerPage = lazy(() => import('./pages/WebdesignAalsmeerPage').then(m => ({
  default: m.WebdesignAalsmeerPage
})));
const WebdesignUithoornPage = lazy(() => import('./pages/WebdesignUithoornPage').then(m => ({
  default: m.WebdesignUithoornPage
})));
const WebdesignOuderAmstelPage = lazy(() => import('./pages/WebdesignOuderAmstelPage').then(m => ({
  default: m.WebdesignOuderAmstelPage
})));
const WebdesignDiemenPage = lazy(() => import('./pages/WebdesignDiemenPage').then(m => ({
  default: m.WebdesignDiemenPage
})));
const WebdesignBlaricumPage = lazy(() => import('./pages/WebdesignBlaricumPage').then(m => ({
  default: m.WebdesignBlaricumPage
})));
const WebdesignLarenPage = lazy(() => import('./pages/WebdesignLarenPage').then(m => ({
  default: m.WebdesignLarenPage
})));
const WebdesignWijdemerenPage = lazy(() => import('./pages/WebdesignWijdemerenPage').then(m => ({
  default: m.WebdesignWijdemerenPage
})));
// Other pages
const AlleLocatiesPage = lazy(() => import('./pages/AlleLocatiesPage').then(m => ({
  default: m.AlleLocatiesPage
})));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then(m => ({
  default: m.NotFoundPage
})));
// Loading fallback
function PageLoader() {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-0">
      <div className="flex flex-col items-center gap-4" data-id="element-1">
        <div className="w-10 h-10 border-3 border-navy-200 border-t-accent rounded-full animate-spin" data-id="element-2" />
        <p className="text-sm text-navy-400 font-medium" data-id="element-3">Laden...</p>
      </div>
    </div>;
}
export function App() {
  return <HashRouter data-id="element-4">
      <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-5">
        <Header data-id="element-6" />
        <div className="flex-grow" data-id="element-7">
          <Suspense fallback={<PageLoader data-id="element-9" />} data-id="element-8">
            <Routes data-id="element-10">
              <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
              <Route path="/website-laten-maken" element={<WebsiteLatenMakenPage data-id="element-14" />} data-id="element-13" />
              <Route path="/seo-voor-websites" element={<SeoVoorWebsitesPage data-id="element-16" />} data-id="element-15" />
              <Route path="/wordpress-websites" element={<WordPressWebsitesPage data-id="element-18" />} data-id="element-17" />
              <Route path="/hosting-onderhoud" element={<HostingOnderhoudPage data-id="element-20" />} data-id="element-19" />
              <Route path="/website-hosting" element={<WebsiteHostingPage data-id="element-22" />} data-id="element-21" />
              <Route path="/website-laten-maken-alkmaar" element={<WebsiteLatenMakenAlkmaarPage data-id="element-24" />} data-id="element-23" />
              <Route path="/kosten-website-laten-maken" element={<KostenWebsiteLatenMakenPage data-id="element-26" />} data-id="element-25" />
              <Route path="/website-laten-maken-checklist" element={<WebsiteLatenMakenChecklistPage data-id="element-28" />} data-id="element-27" />
              <Route path="/website-laten-maken-of-zelf-bouwen" element={<WebsiteLatenMakenOfZelfBouwenPage data-id="element-30" />} data-id="element-29" />
              <Route path="/wordpress-vs-wix" element={<WordPressVsWixPage data-id="element-32" />} data-id="element-31" />
              <Route path="/kennisbank" element={<KennisbankPage data-id="element-34" />} data-id="element-33" />
              <Route path="/wordpress-website-alkmaar" element={<WordPressWebsiteAlkmaarPage data-id="element-36" />} data-id="element-35" />
              <Route path="/wordpress-onderhoud" element={<WordPressOnderhoudPage data-id="element-38" />} data-id="element-37" />
              <Route path="/website-onderhoud" element={<WebsiteOnderhoudPage data-id="element-40" />} data-id="element-39" />
              <Route path="/website-beveiliging" element={<WebsiteBeveiligingPage data-id="element-42" />} data-id="element-41" />
              <Route path="/website-tips" element={<WebsiteTipsPage data-id="element-44" />} data-id="element-43" />
              <Route path="/website-voorbeelden" element={<WebsiteVoorbeeldenPage data-id="element-46" />} data-id="element-45" />
              <Route path="/website-marketing" element={<WebsiteMarketingPage data-id="element-48" />} data-id="element-47" />
              <Route path="/portfolio" element={<PortfolioPage data-id="element-50" />} data-id="element-49" />

              {/* Sector Routes */}
              <Route path="/sector/zakelijke-dienstverlening" element={<SectorZakelijkeDienstverleningPage data-id="element-52" />} data-id="element-51" />
              <Route path="/sector/bouw-installatie" element={<SectorBouwInstallatiePage data-id="element-54" />} data-id="element-53" />
              <Route path="/sector/makelaars-vastgoed" element={<SectorMakelaarsVastgoedPage data-id="element-56" />} data-id="element-55" />
              <Route path="/sector/zorgpraktijken" element={<SectorZorgpraktijkenPage data-id="element-58" />} data-id="element-57" />
              <Route path="/sector/horeca-hospitality" element={<SectorHorecaHospitalityPage data-id="element-60" />} data-id="element-59" />
              <Route path="/sector/coaches-consultants" element={<SectorCoachesConsultantsPage data-id="element-62" />} data-id="element-61" />
              <Route path="/sector/lokale-retail" element={<SectorLokaleRetailPage data-id="element-64" />} data-id="element-63" />

              {/* Cluster Routes */}
              <Route path="/sector/zakelijke-dienstverlening/accountant" element={<ClusterAccountantPage data-id="element-66" />} data-id="element-65" />
              <Route path="/cluster/kosten-website-accountant" element={<KostenWebsiteAccountantPage data-id="element-68" />} data-id="element-67" />
              <Route path="/sector/bouw-installatie/bouwbedrijf" element={<ClusterBouwbedrijfPage data-id="element-70" />} data-id="element-69" />
              <Route path="/sector/bouw-installatie/loodgieter" element={<ClusterLoodgieterPage data-id="element-72" />} data-id="element-71" />
              <Route path="/sector/bouw-installatie/elektricien" element={<ClusterElektricienPage data-id="element-74" />} data-id="element-73" />
              <Route path="/sector/bouw-installatie/dakdekker" element={<ClusterDakdekkerPage data-id="element-76" />} data-id="element-75" />
              <Route path="/sector/makelaars-vastgoed/makelaar" element={<ClusterMakelaarPage data-id="element-78" />} data-id="element-77" />
              <Route path="/sector/makelaars-vastgoed/projectontwikkelaar" element={<ClusterProjectontwikkelaarPage data-id="element-80" />} data-id="element-79" />
              <Route path="/sector/makelaars-vastgoed/vastgoedbeheer" element={<ClusterVastgoedbeheerPage data-id="element-82" />} data-id="element-81" />
              <Route path="/sector/makelaars-vastgoed/woningpresentatie" element={<ClusterWoningpresentatiePage data-id="element-84" />} data-id="element-83" />
              <Route path="/sector/zorgpraktijken/fysiotherapie" element={<ClusterFysiotherapiePage data-id="element-86" />} data-id="element-85" />
              <Route path="/sector/zorgpraktijken/tandarts" element={<ClusterTandartsPage data-id="element-88" />} data-id="element-87" />
              <Route path="/sector/zorgpraktijken/huisarts" element={<ClusterHuisartsPage data-id="element-90" />} data-id="element-89" />
              <Route path="/sector/zorgpraktijken/psycholoog" element={<ClusterPsycholoogPage data-id="element-92" />} data-id="element-91" />
              <Route path="/sector/horeca-hospitality/restaurant" element={<ClusterRestaurantPage data-id="element-94" />} data-id="element-93" />
              <Route path="/sector/horeca-hospitality/hotel-bb" element={<ClusterHotelBbPage data-id="element-96" />} data-id="element-95" />
              <Route path="/sector/horeca-hospitality/cafe-lunchroom" element={<ClusterCafeLunchroomPage data-id="element-98" />} data-id="element-97" />
              <Route path="/sector/horeca-hospitality/afhaal-bezorg" element={<ClusterAfhaalBezorgPage data-id="element-100" />} data-id="element-99" />
              <Route path="/sector/coaches-consultants/coaching" element={<ClusterCoachingPage data-id="element-102" />} data-id="element-101" />
              <Route path="/sector/coaches-consultants/consultant" element={<ClusterConsultantPage data-id="element-104" />} data-id="element-103" />
              <Route path="/sector/coaches-consultants/sportschool" element={<ClusterSportschoolPage data-id="element-106" />} data-id="element-105" />
              <Route path="/sector/coaches-consultants/personal-trainer" element={<ClusterPersonalTrainerPage data-id="element-108" />} data-id="element-107" />
              <Route path="/sector/lokale-retail/kapsalon" element={<ClusterKapsalonPage data-id="element-110" />} data-id="element-109" />
              <Route path="/sector/lokale-retail/fietsenwinkel" element={<ClusterFietsenwinkelPage data-id="element-112" />} data-id="element-111" />
              <Route path="/sector/lokale-retail/garage" element={<ClusterGaragePage data-id="element-114" />} data-id="element-113" />
              <Route path="/sector/lokale-retail/autobedrijf" element={<ClusterAutobedrijfPage data-id="element-116" />} data-id="element-115" />

              {/* New high-intent routes */}
              <Route path="/accountant-amsterdam" element={<AccountantAmsterdamPage data-id="element-118" />} data-id="element-117" />
              <Route path="/financieel-adviseur-amsterdam" element={<FinancieelAdviseurAmsterdamPage data-id="element-120" />} data-id="element-119" />

              {/* Local SEO routes */}
              <Route path="/webdesign-alkmaar" element={<WebdesignAlkmaarPage data-id="element-122" />} data-id="element-121" />
              <Route path="/webdesign-heerhugowaard" element={<WebdesignHeerhugowaardPage data-id="element-124" />} data-id="element-123" />
              <Route path="/webdesign-hoorn" element={<WebdesignHoornPage data-id="element-126" />} data-id="element-125" />
              <Route path="/webdesign-schagen" element={<WebdesignSchagenPage data-id="element-128" />} data-id="element-127" />
              <Route path="/webdesign-den-helder" element={<WebdesignDenHelderPage data-id="element-130" />} data-id="element-129" />
              <Route path="/webdesign-dijk-en-waard" element={<WebdesignDijkEnWaardPage data-id="element-132" />} data-id="element-131" />
              <Route path="/webdesign-castricum" element={<WebdesignCastricumPage data-id="element-134" />} data-id="element-133" />
              <Route path="/webdesign-heiloo" element={<WebdesignHeilooPage data-id="element-136" />} data-id="element-135" />
              <Route path="/webdesign-uitgeest" element={<WebdesignUitgeestPage data-id="element-138" />} data-id="element-137" />
              <Route path="/webdesign-bergen" element={<WebdesignBergenPage data-id="element-140" />} data-id="element-139" />
              <Route path="/webdesign-purmerend" element={<WebdesignPurmerendPage data-id="element-142" />} data-id="element-141" />
              <Route path="/webdesign-haarlem" element={<WebdesignHaarlemPage data-id="element-144" />} data-id="element-143" />
              <Route path="/webdesign-zaanstad" element={<WebdesignZaanstadPage data-id="element-146" />} data-id="element-145" />
              <Route path="/webdesign-haarlemmermeer" element={<WebdesignHaarlemmermeerPage data-id="element-148" />} data-id="element-147" />
              <Route path="/webdesign-amsterdam" element={<WebdesignAmsterdamPage data-id="element-150" />} data-id="element-149" />
              <Route path="/webdesign-amstelveen" element={<WebdesignAmstelveenPage data-id="element-152" />} data-id="element-151" />
              <Route path="/webdesign-hilversum" element={<WebdesignHilversumPage data-id="element-154" />} data-id="element-153" />
              <Route path="/webdesign-huizen" element={<WebdesignHuizenPage data-id="element-156" />} data-id="element-155" />
              <Route path="/webdesign-gooise-meren" element={<WebdesignGooiseMerenPage data-id="element-158" />} data-id="element-157" />
              <Route path="/webdesign-velsen" element={<WebdesignVelsenPage data-id="element-160" />} data-id="element-159" />
              <Route path="/webdesign-beverwijk" element={<WebdesignBeverwijkPage data-id="element-162" />} data-id="element-161" />
              <Route path="/webdesign-heemskerk" element={<WebdesignHeemskerkPage data-id="element-164" />} data-id="element-163" />
              <Route path="/webdesign-texel" element={<WebdesignTexelPage data-id="element-166" />} data-id="element-165" />
              <Route path="/webdesign-medemblik" element={<WebdesignMedemblikPage data-id="element-168" />} data-id="element-167" />
              <Route path="/webdesign-enkhuizen" element={<WebdesignEnkhuizenPage data-id="element-170" />} data-id="element-169" />
              <Route path="/webdesign-stede-broec" element={<WebdesignStedeBroecPage data-id="element-172" />} data-id="element-171" />
              <Route path="/webdesign-drechterland" element={<WebdesignDrechterlandPage data-id="element-174" />} data-id="element-173" />
              <Route path="/webdesign-koggenland" element={<WebdesignKoggenlandPage data-id="element-176" />} data-id="element-175" />
              <Route path="/webdesign-opmeer" element={<WebdesignOpmeerPage data-id="element-178" />} data-id="element-177" />
              <Route path="/webdesign-hollands-kroon" element={<WebdesignHollandsKroonPage data-id="element-180" />} data-id="element-179" />
              <Route path="/webdesign-edam-volendam" element={<WebdesignEdamVolendamPage data-id="element-182" />} data-id="element-181" />
              <Route path="/webdesign-waterland" element={<WebdesignWaterlandPage data-id="element-184" />} data-id="element-183" />
              <Route path="/webdesign-landsmeer" element={<WebdesignLandsmeerPage data-id="element-186" />} data-id="element-185" />
              <Route path="/webdesign-oostzaan" element={<WebdesignOostzaanPage data-id="element-188" />} data-id="element-187" />
              <Route path="/webdesign-wormerland" element={<WebdesignWormerlandPage data-id="element-190" />} data-id="element-189" />
              <Route path="/webdesign-bloemendaal" element={<WebdesignBloemendaalPage data-id="element-192" />} data-id="element-191" />
              <Route path="/webdesign-heemstede" element={<WebdesignHeemstedePage data-id="element-194" />} data-id="element-193" />
              <Route path="/webdesign-zandvoort" element={<WebdesignZandvoortPage data-id="element-196" />} data-id="element-195" />
              <Route path="/webdesign-aalsmeer" element={<WebdesignAalsmeerPage data-id="element-198" />} data-id="element-197" />
              <Route path="/webdesign-uithoorn" element={<WebdesignUithoornPage data-id="element-200" />} data-id="element-199" />
              <Route path="/webdesign-ouder-amstel" element={<WebdesignOuderAmstelPage data-id="element-202" />} data-id="element-201" />
              <Route path="/webdesign-diemen" element={<WebdesignDiemenPage data-id="element-204" />} data-id="element-203" />
              <Route path="/webdesign-blaricum" element={<WebdesignBlaricumPage data-id="element-206" />} data-id="element-205" />
              <Route path="/webdesign-laren" element={<WebdesignLarenPage data-id="element-208" />} data-id="element-207" />
              <Route path="/webdesign-wijdemeren" element={<WebdesignWijdemerenPage data-id="element-210" />} data-id="element-209" />

              <Route path="/alle-locaties" element={<AlleLocatiesPage data-id="element-212" />} data-id="element-211" />
              <Route path="/portfolio" element={<PortfolioPage data-id="element-214" />} data-id="element-213" />
              <Route path="*" element={<NotFoundPage data-id="element-216" />} data-id="element-215" />
            </Routes>
          </Suspense>
        </div>
        <Footer data-id="element-217" />
        <CookieConsent data-id="element-218" />
      </div>
    </HashRouter>;
}